import { createFileRoute } from '@tanstack/react-router'

import { CreateOrganizationPage } from '../../../components/pages/backoffice/platform/create-organization-page/create-organization-page.tsx'
import { PermissionChecker } from '../../../components/templates/permission-checker.tsx'

export const Route = createFileRoute('/bo/organizations/create')({
  component: () => (
    <PermissionChecker requiredPermissions={['organization.create']}>
      <CreateOrganizationPage />
    </PermissionChecker>
  ),
})
